<template>
  <div>
    <v-col v-if="vehicles.length > 0">
      <v-row>
        <v-col cols="12" sm="6">
          <v-select
              v-model="filter.period"
              :items="periods"
              label="Período"
              item-text="value"
              return-object
              @change="search(filter)"
              outlined
              dense
          ></v-select>
        </v-col>
        <v-col cols="12" sm="6">
          <v-select
              v-model="filter.vehicle"
              :items="vehicles"
              item-text="plate"
              label="Veículo"
              required
              return-object
              @change="search(filter)"
              outlined
              dense
          ></v-select>
        </v-col>
      </v-row>

      <v-row class="mb-4">
        <v-col cols="12" class="d-flex justify-end flex-wrap export-buttons">
          <v-btn
              color="primary"
              class="ma-1"
              :loading="pdfLoading"
              :disabled="emailLoading || loading || rows.length === 0"
              @click="downloadPdf"
              elevation="2"
          >
            <span class="d-none d-sm-inline">Baixar PDF</span>
            <span class="d-inline d-sm-none">PDF</span>
          </v-btn>

          <v-btn
              color="secondary"
              class="ma-1"
              :loading="emailLoading"
              :disabled="pdfLoading || loading || rows.length === 0"
              @click="sendPdfEmail"
              elevation="2"
          >
            <span class="d-none d-sm-inline">Enviar por Email</span>
            <span class="d-inline d-sm-none">Email</span>
          </v-btn>
        </v-col>
      </v-row>

      <v-layout v-resize="onResize">
        <v-col class="px-0">
          <v-data-table
              :hide-default-header="isMobile"
              :headers="headers"
              :items="rows"
              :loading="loading"
              locale="pt-BR"
              :hide-default-footer="rows.length === 0 || rows.length < 10"
              class="elevation-1"
          >
            <template v-slot:item.created_at="{ item }">
              {{ item.created_at | timeStampToHuman }}
            </template>
            <template v-slot:item.amount="{ item }">
              R$ {{ item.amount | integerToMoney | integerToMoney2 }}
            </template>
            <template slot="no-data">
              Nenhum dado encontrado.
            </template>
            <template slot="loading">
              Carregando
            </template>
          </v-data-table>
        </v-col>
      </v-layout>
    </v-col>

    <div class="message-data text-center" v-show="vehicles.length === 0 && loading === false">
      <i class="far fa-bell"></i>
      <span>Você não possui nenhum veículo cadastrado.</span>
    </div>

    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.color"
        :timeout="snackbar.timeout"
        bottom
        right
    >
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn
            text
            v-bind="attrs"
            @click="snackbar.show = false"
        >
          Fechar
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import PdfExportService from '../services/PdfExportService';

export default {
  name: "VehiclesHistory",
  data: function () {
    return {
      isMobile: false,
      filter: {
        vehicle: {
          plate: 'Nenhum veículo encontrado.'
        },
        period: null
      },
      vehicles: [],
      periods: [
        {label: 0, value: 'Todo o período'},
        {label: 1, value: 'Hoje'},
        {label: 2, value: 'Os últimos 7 dias'},
        {label: 3, value: 'Esse mês'},
        {label: 4, value: 'Mês anterior'},
        {label: 5, value: 'Esse ano'}
      ],
      loading: false,
      pdfLoading: false,
      emailLoading: false,
      snackbar: {
        show: false,
        text: '',
        color: 'success',
        timeout: 4000
      },
      headers: [
        {text: 'Operação', sortable: false, value: 'type_name'},
        {text: 'Data', sortable: false, value: 'created_at'},
        {text: 'Forma de Pagamento', sortable: false, value: 'payment_form_name'},
        {text: 'Valor', sortable: false, value: 'amount'},
      ],
      rows: []
    };
  },
  mounted() {
    this.loadVehicles();
  },
  methods: {
    showSnackbar(text, color = 'success') {
      this.snackbar.text = text;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    onResize() {
      this.isMobile = window.innerWidth < 769;
    },
    loadVehicles() {
      this.loading = true;

      axios.get('/api/users/driver/me/plate').then(res => {
        res.data.data.forEach(vehicle => {
          if (vehicle.wallet !== null && this.userId === vehicle.wallet.user_id) {
            this.vehicles.push(vehicle);
          }
        });

        if (this.vehicles.length > 0) {
          this.filter.vehicle = this.vehicles[0];
        }

        this.filter.period = this.periods[0];
        this.search(this.filter);
      }).catch(() => {
        this.showSnackbar('Erro ao carregar veículos. Tente novamente.', 'error');
      }).finally(() => {
        this.loading = false;
      });
    },
    buildFilterParams(filter) {
      const params = {};

      if (filter.vehicle.plate !== 'Nenhum veículo encontrado.') {
        params.plate = filter.vehicle.plate;
      }

      switch (filter.period.label) {
        case 1:
          params.created_at_begin = moment().format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().format('YYYY-MM-DD 23:59:59');
          break;
        case 2:
          params.created_at_begin = moment().subtract('7', 'days').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().format('YYYY-MM-DD 23:59:59');
          break;
        case 3:
          params.created_at_begin = moment().startOf('month').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().endOf('month').format('YYYY-MM-DD 23:59:59');
          break;
        case 4:
          params.created_at_begin = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD 23:59:59');
          break;
        case 5:
          params.created_at_begin = moment().startOf('year').format('YYYY-MM-DD 00:00:00');
          params.created_at_end = moment().endOf('year').format('YYYY-MM-DD 23:59:59');
          break;
      }

      return params;
    },
    search(filter) {
      const params = this.buildFilterParams(filter);

      if (!params.plate) {
        return;
      }

      this.loading = true;

      axios.get('/api/users/driver/me/app/transaction', {params}).then(res => {
        this.rows = res.data.data;
      }).catch(() => {
        this.showSnackbar('Erro ao buscar histórico. Tente novamente.', 'error');
      }).finally(() => {
        this.loading = false;
      });
    },
    async downloadPdf() {
      const params = this.buildFilterParams(this.filter);

      if (!params.plate) {
        this.showSnackbar('Selecione um veículo válido.', 'warning');
        return;
      }

      this.pdfLoading = true;

      try {
        await PdfExportService.downloadPdf(
            '/api/users/driver/me/app/transaction/pdf',
            params
        );
        this.showSnackbar('PDF baixado com sucesso!');
      } catch (error) {
        this.showSnackbar(
            error.message || 'Ocorreu um problema ao gerar o PDF. Tente novamente mais tarde!',
            'error'
        );
      } finally {
        this.pdfLoading = false;
      }
    },
    async sendPdfEmail() {
      const params = this.buildFilterParams(this.filter);

      if (!params.plate) {
        this.showSnackbar('Selecione um veículo válido.', 'warning');
        return;
      }

      this.emailLoading = true;

      try {
        await PdfExportService.sendPdfEmail(
            '/api/users/driver/me/app/transaction/email',
            params
        );
        this.showSnackbar('O relatório em PDF foi enviado para o email cadastrado!');
      } catch (error) {
        this.showSnackbar(
            error.message || 'Ocorreu um erro ao enviar o email. Tente novamente mais tarde.',
            'error'
        );
      } finally {
        this.emailLoading = false;
      }
    }
  },
  computed: {
    userId() {
      return JSON.parse(localStorage.getItem('user')).id;
    },
    advancedWalletOptions: function () {
      return process.env.VUE_APP_ADVANCED_WALLET_OPTIONS;
    },
    showWallets() {
      return process.env.VUE_APP_SHOW_WALLETS;
    }
  }
};
</script>

<style scoped>
.export-buttons {
  gap: 8px;
}

@media only screen and (max-width: 600px) {
  .export-buttons {
    justify-content: center !important;
  }
}
</style>
